export default "__VITE_ASSET__DCROeKbj__"